import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
export default {
  name: "rank",
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo"])
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          this.setWowAnim();
          this.ranklist = await this.getPersonalRank();
          this.initFn();
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      ranklist: null
    };
  },
  methods: {
    ...userVuex.mapActions(["getPersonalRank"]),
    async initFn() {
      this.$nextTick(() => {
        try {
          const mRankRef = this.$refs.mRankRef;
          if (!mRankRef) {
            mRankRef.init();
          }
        } catch (err) {}
      });
    }
  },
  async mounted() {}
};